import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { industries } from "../data/site";

// Asymmetric span pattern for visual rhythm
const spans = [
  "md:col-span-7 md:row-span-2 aspect-[16/12]",
  "md:col-span-5 aspect-[16/10]",
  "md:col-span-5 aspect-[16/10]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-12 aspect-[21/9]",
];

export default function IndustriesSection() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-28 md:py-40 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Industries Served"
          title="Every typology. Every authority."
          description="From boutique residences to multi-tower townships, hospitals and IT campuses — we work alongside developers across the full spectrum of the built environment."
          testId="industries-heading"
        />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-[minmax(0,auto)]">
          {industries.map((it, i) => (
            <motion.div
              key={it.name}
              data-testid={`industry-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.08 }}
              className={`industry-card relative overflow-hidden rounded-2xl border border-white/5 group ${
                spans[i] || "md:col-span-4 aspect-[4/5]"
              }`}
            >
              <img
                src={it.img}
                alt={it.name}
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-[#C96A2B]/25" />
              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                <span className="eyebrow">0{i + 1}</span>
                <h3 className="font-display text-2xl md:text-3xl mt-2">{it.name}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
